'use client';

import { useState } from 'react';
import * as Popover from '@/app_components/ui/Popover';

interface InfoIconProps {
  tooltip: string;
  side?: 'bottom' | 'left' | 'right' | 'top';
  align?: 'center' | 'end' | 'start';
}

export const InfoIcon = ({ tooltip, side = 'bottom', align = 'start' }: InfoIconProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const handleToggle = (e: React.MouseEvent | React.KeyboardEvent) => {
    setIsClicked((prev) => !prev);
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    /** biome-ignore lint/a11y/useSemanticElements: Check with platform team */
    <div
      onClick={handleToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleToggle(e);
        }
      }}
      onMouseLeave={() => setIsOpen(false)}
      role='button'
      tabIndex={0}
    >
      <Popover.Root
        modal={false}
        onOpenChange={setIsClicked}
        open={isOpen || isClicked}
      >
        <Popover.Trigger
          asChild
          className='flex items-start gap-2'
        >
          {/** biome-ignore lint/a11y/useSemanticElements: <@Daniel @James please address this> */}
          <span
            className='icon icon-info-circle w-5 h-5 text-accent-primary cursor-pointer'
            onMouseEnter={() => setIsOpen(true)}
            role='button'
            tabIndex={0}
          />
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content
            align={align}
            className='w-[175px] absolute focus-visible:outline-0 bg-white p-2 shadow-[2px_2px_4px] shadow-neutrals-300 border-t-4 border-brand-primary'
            side={side}
          >
            <p className='font-graphik-compact typography-heading-graphik-condensed-level-6 font-normal text-neutrals-800'>
              {tooltip}
            </p>
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </div>
  );
};
